// Resume data extracted from Vaibhav Bhore's official PDF resume
export const resumeData = {
  personal: {
    name: "Vaibhav Vivek Bhore",
    title: "Product & Project Leader",
    subtitle: "15 Years in WealthTech, Broking & Digital Investment Platforms",
    email: "vbhore@gmail.com",
    phone: "+91 9930860959",
    location: "Hiranandani Estate Patlipada, Thane (W), Maharashtra",
    linkedin: "https://linkedin.com/in/vaibhav-b-47b699a/",
    profileImage: "https://customer-assets.emergentagent.com/job_cv-builder-187/artifacts/yjktx56u_WhatsApp%20Image%202026-02-11%20at%208.52.06%20PM.jpeg",
    resumePdf: "https://customer-assets.emergentagent.com/job_cv-builder-187/artifacts/xxn9h3uw_Vaibhav_Bhore_Project_Management_11%20Feb%202026%20%281%29.pdf",
    summary: "Results-driven Product & Project Leader with 15 years of experience across WealthTech, Broking, and Digital Investment Platforms. Currently serving as Associate Director at Reedos Software Solutions Private Limited, where I spearhead initiatives in digital transformation, portfolio intelligence, and multi-asset advisory. Deep domain expertise in broking operations, multi-asset product strategy, and data-centric platforms tailored for HNI/UHNI clients. Adept at bridging business, technology, and compliance across stakeholders.",
    headline: "Seeking to contribute to a progressive financial institution, where innovation, regulatory-aligned product design, and digital transformation converge to scale wealth management and retail banking platforms.",
    dob: "11th April 1986",
    languages: ["Marathi", "English", "Hindi"]
  },
  stats: [
    { value: "15+", label: "Years Experience" },
    { value: "5+", label: "Companies" },
    { value: "15+", label: "Major Projects" },
    { value: "94K Cr+", label: "AUM Managed" }
  ],
  synopsis: [
    "Rolled out 100% accurate client report across 7 asset classes and 48 products",
    "Rolled out Portfolio analysis tool and Digital account opening in a year",
    "Managed Project Transcend with IBM for Edelweiss Transformation Journey",
    "Successfully implemented 15+ small and large projects at Edelweiss",
    "Led team of 10 business intelligence professionals for PAN India MIS"
  ],
  expertise: [
    "Process Improvement",
    "Business Analysis",
    "Operations Management",
    "Product Development",
    "Project Management",
    "Stock Reconciliation"
  ],
  experience: [
    {
      id: 1,
      company: "Reedos Software Solutions Private Limited",
      title: "Associate Director - Marketing",
      duration: "Dec 2025 - Present",
      location: "Mumbai, India",
      description: "Responsible for marketing strategy, client engagement, and business development initiatives.",
      highlights: [
        "Product Marketing and Platform Design",
        "Driving product adoption and client trainings",
        "Strategic client engagement and business development",
        "Spearheading digital transformation initiatives"
      ],
      current: true
    },
    {
      id: 2,
      company: "Nuvama Wealth Management Ltd",
      title: "Associate Director (Head of Product Development)",
      duration: "Sep 2021 - Sep 2025",
      totalDuration: "4 years",
      location: "Mumbai, Maharashtra, India",
      description: "Responsible for Client Reports for better analysis of portfolio. Led key initiatives in Project Management, Platform Design, Product adoption, and trainings.",
      highlights: [
        "Led design and implementation of Multi-Asset Recommendation System (MARS)",
        "Delivered robust reporting suite for 5 lakh+ clients and 1,500+ RMs",
        "Achieved 99% error reduction; monthly QRC down by 85%",
        "350+ reports rationalized into 17 high-utility formats",
        "CSAT score of 92%; high field adoption in client conversations"
      ],
      current: false
    },
    {
      id: 3,
      company: "Yes Securities Ltd",
      title: "Assistant Vice President",
      duration: "May 2020 - Aug 2021",
      totalDuration: "1 yr 4 mos",
      location: "Mumbai, India",
      description: "Responsible for Data Warehouse, Portfolio Advisor (Learning Academy) and Digitization of account opening process.",
      highlights: [
        "Project Management and Vendor Management",
        "Data Warehouse implementation",
        "Portfolio Advisor platform development",
        "Digitization of account opening process"
      ],
      current: false
    },
    {
      id: 4,
      company: "Edelweiss Broking Ltd",
      title: "Chief Manager",
      duration: "Feb 2013 - Jan 2020",
      totalDuration: "7 years",
      location: "Mumbai, India",
      description: "Senior Business Analyst leading 5-member BA team. Successfully implemented 15+ small and large projects. Led team of 10 business intelligence professionals.",
      highlights: [
        "Lead of 5-member Business Analyst team",
        "Successfully implemented 15+ projects including Franchisee Portal, CRM, Data Warehouse",
        "Led team of 10 business intelligence professionals",
        "Prepared daily business revenue MIS for all branches across PAN India",
        "Track Lead for CRM, BPM and IM in Project Transcend with IBM"
      ],
      current: false
    },
    {
      id: 5,
      company: "Edelweiss Capital Ltd",
      title: "Associate",
      duration: "June 2007 - Aug 2010",
      totalDuration: "3 yrs 2 mos",
      location: "Mumbai, India",
      description: "Back-office operations executive handling collateral management and billing process for institutional clients.",
      highlights: [
        "Collateral management and Billing process for institutional clients",
        "Product manager for lending products",
        "Successfully implemented ESOP Funding, Loan against shares, IPO funding"
      ],
      current: false
    }
  ],
  education: [
    {
      id: 1,
      institution: "Welingkar Institute of Management",
      degree: "PGDM (Business Design & Innovation)",
      duration: "2011 - 2013",
      grade: "64%",
      description: "Post Graduate Diploma in Management with specialization in Business Design & Innovation"
    },
    {
      id: 2,
      institution: "V.G. Vaze College, Mumbai University",
      degree: "B.Com (Accounting & Finance)",
      duration: "2004 - 2007",
      grade: "68%",
      description: "Bachelor of Commerce with focus on Accounting and Finance"
    },
    {
      id: 3,
      institution: "J.C. Junior College",
      degree: "12th - Maharashtra Board",
      duration: "2004",
      grade: "69%",
      description: "Higher Secondary Education"
    },
    {
      id: 4,
      institution: "J.C. High School",
      degree: "10th - Maharashtra Board",
      duration: "2002",
      grade: "73.5%",
      description: "Secondary School Education"
    }
  ],
  skills: {
    core: [
      { name: "Product Development", endorsements: 12 },
      { name: "Project Management", endorsements: 15 },
      { name: "WealthTech", endorsements: 10 },
      { name: "Digital Transformation", endorsements: 9 },
      { name: "Business Analysis", endorsements: 11 },
      { name: "Process Improvement", endorsements: 8 },
      { name: "Multi-Asset Advisory", endorsements: 7 },
      { name: "Operations Management", endorsements: 10 },
      { name: "HNI/UHNI Client Management", endorsements: 8 },
      { name: "Data Analytics", endorsements: 9 }
    ],
    technical: [
      "QlikView (BI Tool)",
      "Data Warehouse",
      "CRM Systems",
      "BPM Workflows",
      "MIS Reporting",
      "Platform Design",
      "SQL & Data Analysis"
    ]
  },
  projects: [
    {
      id: 1,
      title: "Multi-Asset Recommendation System (MARS)",
      company: "Nuvama Wealth Management",
      duration: "2023 - 2025",
      description: "Award-winning unified platform empowering 1,500+ Relationship Managers with structured, consistent, and client-centric advice across equities, debt, and structured products. MARS standardizes the advisory process and enhances client engagement through a scalable, intuitive interface.",
      challenge: "Relationship Managers were using disparate tools and inconsistent processes across different asset classes, leading to fragmented client experiences and reduced advisory quality. The lack of a unified platform resulted in missed opportunities and compliance risks.",
      solution: "Designed and implemented a comprehensive multi-asset recommendation engine that provides RMs with a single dashboard for all asset classes, AI-powered insights, and standardized workflows. The platform ensures regulatory compliance while enabling personalized client advisory.",
      role: "Led the end-to-end product development as Head of Product Development. Managed cross-functional teams including developers, business analysts, and compliance officers. Drove user research, defined product roadmap, and oversaw successful deployment across all branches.",
      achievements: [
        "Unified all asset classes under one accessible RM platform",
        "Successfully deployed across branches within 6 months",
        "Improved advisory quality, satisfaction, and retention",
        "Future-ready roadmap including Gen AI integration plans",
        "92% CSAT score from RMs and clients",
        "Reduced client onboarding time by 40%"
      ],
      technologies: ["React", "Node.js", "PostgreSQL", "AWS", "Tableau", "RESTful APIs"],
      tags: ["WealthTech", "Advisory Platform", "Product Design", "Digital Transformation"]
    },
    {
      id: 2,
      title: "Client Reporting Engine",
      company: "Nuvama Wealth Management",
      duration: "2022 - 2024",
      description: "Transformed reporting framework into a real-time, unified, and scalable system supporting 94,000 Cr+ AUM daily across 30+ financial products and 7 asset classes. Serves 5 lakh+ clients, 1,500+ RMs, and 20,000+ partners.",
      challenge: "Legacy reporting system had 350+ fragmented reports causing confusion, data inconsistencies, and high error rates. Monthly QRC (Quality Related Complaints) were affecting client trust and RM productivity.",
      solution: "Built a centralized reporting engine with real-time data synchronization, automated SEBI-compliant corporate action processing, and intelligent report consolidation. Implemented quality checks at every data touchpoint.",
      role: "Spearheaded the complete transformation initiative. Conducted stakeholder interviews, mapped existing pain points, designed the new architecture, and managed the migration strategy ensuring zero downtime.",
      achievements: [
        "99% error reduction; monthly QRC down by 85%",
        "350+ reports rationalized into 17 high-utility formats",
        "Real-time SEBI-compliant corporate action automation",
        "CSAT score of 92% - highest in reporting history",
        "Reduced report generation time from hours to minutes",
        "Enabled self-service reporting for partners"
      ],
      technologies: ["QlikView", "SQL Server", "Python", "Tableau", "REST APIs", "AWS Lambda"],
      tags: ["Reporting", "Data Analytics", "Compliance", "Business Intelligence"]
    },
    {
      id: 3,
      title: "Project Transcend",
      company: "Edelweiss (with IBM)",
      duration: "2015 - 2018",
      description: "Consulting engagement with IBM for Edelweiss Transformation Journey. Key objectives: improving customer experience, increasing business productivity and operational efficiency through CRM, BPM, DMS, Information Management, and Campaign Management.",
      challenge: "Account opening TAT was 48 hours, customer data was siloed across systems, and sales teams lacked a unified view of client interactions. Manual processes were causing delays and errors.",
      solution: "Implemented Pivotal CRM for wealth management, standardized DataMart for key performance metrics, deployed BPM workflows for account opening, and integrated DMS for document management.",
      role: "Track Lead for CRM, BPM, and Information Management tracks. Coordinated between IBM consultants and internal teams. Managed vendor relationships and ensured timely delivery of all milestones.",
      achievements: [
        "Reduced account opening TAT from 48 hours to 2 hours",
        "Implemented Pivotal CRM for wealth management",
        "Standardized DataMart for key performance metrics",
        "Deployed enterprise-wide BPM workflows",
        "Achieved 95% user adoption within 3 months",
        "ROI achieved within first year of implementation"
      ],
      technologies: ["Pivotal CRM", "IBM BPM", "Informatica", "Oracle DB", "SharePoint"],
      tags: ["Digital Transformation", "IBM Consulting", "BPM", "CRM", "Enterprise"]
    },
    {
      id: 4,
      title: "Customer Interface Platform (CIP)",
      company: "Edelweiss",
      duration: "2016 - 2019",
      description: "Built internal 360° client view used by RM, service, ops, risk, and product teams. Platform provides all information of clients including personal info, contact details, interactions, assets, and transactions across all products.",
      challenge: "Customer service teams had to access 8+ different systems to get complete client information. This led to long call times, inconsistent service, and frustrated clients.",
      solution: "Created a unified Customer Interface Platform aggregating data from all source systems in real-time. Implemented role-based access, interaction history tracking, and integrated communication channels.",
      role: "Product Manager leading the initiative from concept to deployment. Conducted user research with 50+ stakeholders, created wireframes, managed development sprints, and drove adoption across teams.",
      achievements: [
        "Improved service resolution time by 60%",
        "Unified view for RMs, Customer Service, Risk, Research teams",
        "Integrated all products: broking, mutual funds, insurance, etc.",
        "Reduced average call handling time by 45%",
        "Zero-click customer identification enabled",
        "Won internal innovation award"
      ],
      technologies: ["Angular", "Java", "MongoDB", "Elasticsearch", "Apache Kafka"],
      tags: ["CRM", "Customer 360", "Platform Design", "Service Excellence"]
    }
  ],
  activities: [
    "Member of CII - YI Net Bangalore Chapter",
    "Member of Finance Club 'Arthakul' at Welingkar Institute",
    "Alumni Secretary at Welingkar Institute of Management",
    "Trek Leader: Led group of 25 for trekking at Sahyadri mountains"
  ]
};
